import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { ShoppingCartIcon, UserIcon } from '@heroicons/react/24/outline';

export default function Navbar() {
  const { firebaseUser, currentUser, logout } = useAuth();
  const navigate = useNavigate();

  async function handleLogout() {
    try {
      await logout();
      navigate('/login');
    } catch (error) {
      console.error('Failed to log out:', error);
    }
  }

  return (
    <nav className="bg-white shadow-lg">
      <div className="container mx-auto px-4">
        <div className="flex justify-between items-center h-16">
          <Link to="/" className="text-xl font-bold text-gray-800">
            NexGENGaming
          </Link>

          <div className="flex items-center space-x-4">
            <Link to="/products" className="text-gray-600 hover:text-gray-900">
              Products
            </Link>

            {firebaseUser ? (
              <>
                {currentUser && currentUser.role === 'admin' && (
                  <Link to="/admin" className="text-gray-600 hover:text-gray-900 font-semibold">
                    Admin
                  </Link>
                )}
                {currentUser && currentUser.role === 'rider' && (
                  <Link to="/rider" className="text-gray-600 hover:text-gray-900 font-semibold">
                    Rider
                  </Link>
                )}
                <Link to="/cart" className="text-gray-600 hover:text-gray-900">
                  <ShoppingCartIcon className="h-6 w-6" />
                </Link>
                <Link to="/orders" className="text-gray-600 hover:text-gray-900">
                  Orders
                </Link>
                <Link to="/profile" className="text-gray-600 hover:text-gray-900">
                  <UserIcon className="h-6 w-6" />
                </Link>
                <button
                  onClick={handleLogout}
                  className="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600"
                >
                  Logout
                </button>
              </>
            ) : (
              <Link
                to="/login"
                className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
              >
                Login
              </Link>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
} 